import { render, staticRenderFns } from "./main.vue?vue&type=template&id=6ae8ae40&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=6ae8ae40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae8ae40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae8ae40')) {
      api.createRecord('6ae8ae40', component.options)
    } else {
      api.reload('6ae8ae40', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=6ae8ae40&scoped=true&", function () {
      api.rerender('6ae8ae40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueImageCropper/main.vue"
export default component.exports